/*
 * @Author: your name
 * @Date: 2022-04-02 14:26:49
 * @LastEditTime: 2022-04-02 14:37:33
 * @LastEditors: Please set LastEditors
 * @Description: 正式环境打包的路由
 * @FilePath: \management-admin\src\router\productionRouter.js
 */

export default [
  {
    path: "company",
    name: "company",
    meta: {
      title: "招聘录入"
    },
    component: resolve => require(["@/views/company/companyList.vue"], resolve)
  },
  {
    path: "landlord",
    name: "landlord",
    meta: {
      title: "租房录入"
    },
    component: resolve => require(["@/views/landlord/landlordList.vue"], resolve)
  },
  {
    path: "fileNetworkDisk",
    name: "fileNetworkDisk",
    meta: {
      title: "云盘"
    },
    component: resolve =>
      require(["@/views/fileNetworkDisk/Index.vue"], resolve)
  }
];
